import React from "react";

function TabellaOrariBR() {
    return(
        <div className="table-container">
            <table className="table text-center m-auto" style={{width: "90%"}}>
                <thead>
                <tr>
                    <th className="" scope="col">Lun</th>
                    <th className="" scope="col">Mar</th>
                    <th className="" scope="col">Mer</th>
                    <th className="" scope="col">Gio</th>
                    <th className="" scope="col">Ven</th>
                    <th className="" scope="col">Sab</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="data-cell">16:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:00
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td className="data-cell">16:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:00
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td></td>
                    <td className="data-cell">16:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:00
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td className="data-cell">16:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:00
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td className="data-cell">10:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 11:30
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td/>
                </tr>
                <tr>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td/>
                </tr>
                <tr>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td/>
                </tr>
                </tbody>
            </table>
            <br/>
        </div>
    )
}

export default TabellaOrariBR